export default __webpack_public_path__ + "d083508af3e17e2e30d08c91ab824f43.png";